import * as React from 'react';
import { UIHeading4, UIHeading2, Avatar } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IAgentsItemProps {
  name?: string | null;
  avatarUrl?: string | null;
  controls: React.ReactNode;
  listingLink: React.ReactNode;
}

export function AgentsItem({ name, avatarUrl, controls, listingLink }: IAgentsItemProps) {
  return (
    <div className={styles['container']} data-testid="AgentsItem">
      <div className={styles['present-info']}>
        <div className={styles['title']}>
          <UIHeading4>Агентство недвижимости</UIHeading4>
          <UIHeading2 as="h2">{name}</UIHeading2>
          <div className={styles['listing-link']}>{listingLink}</div>
        </div>
        <div className={styles['avatar']}>
          <Avatar src={avatarUrl} size={60} type="agency" hideBorder />
        </div>
      </div>
      <div className={styles['controls']}>{controls}</div>
    </div>
  );
}
